import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  mainDiv: {
    padding: "15px 32px",
  },
  uiTab: {
    minHeight: "calc(100vh - 270px)",
    height: "100% !important",
  },
  titleStatusBadge: {
    height: "24px !important",
    width: "fit-content !important",
    fontFamily: "Manrope",
    marginRight: "8px",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "16px",
  },
}));

export default styles;
